import React, {Component} from 'react';
import styled from 'styled-components';
import isEqual from 'react-fast-compare';
import CarPage from './CarPage';
import {connect} from 'react-redux';
import {CarsSelectors} from '../../redux/CarsRedux';
import Button from '@atlaskit/button';
import Tabs from '@atlaskit/tabs';
import { Trans } from 'react-i18next';

const AddCarButtonWrapper = styled.div`
  position: absolute;
  top: 4px;
  right: 8px;
  z-index: 490;
`;

const Container = styled.div`
  position: relative;
  & div[role=tablist] {
    margin-right: 80px;
  }
`;

class CarsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastSelected: 0,
      tabSelected: 0,
      setFromHash: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.edit === 'car'
      && !this.props.edit) {
        this.onTabSelect(null, this.state.lastSelected);
    } else if (this.props.location.hash !== ''
      && !this.state.setFromHash
      //&& (!prevProps.cars || prevProps.cars.length === 0)
      && this.props.cars && this.props.cars.length && this.props.cars.length > 0) {
      const index = this.props.cars.map(c => c.id).indexOf(this.props.location.hash.slice(1)*1);
      this.setState({
        tabSelected: index,
        lastSelected: index,
        setFromHash: true});
    }
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {update} = this.props;
    const {client} = this.state;
    let dataForUpdate = {};
    Object.keys(client).map(key => {
      if (!isEqual(client[key], this.props.client[key])) {
        dataForUpdate[key] = client[key];
      }
    })

    if (Object.keys(dataForUpdate).length === 0) {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.

    } else {
      update({
        ...dataForUpdate,
        id: this.props.client.id
      });
    }
  }

  buildContent = cars => {
    let tabs = [];
    if (cars && cars.length) {
      tabs = [...cars.map(car => ({
        label: `${car.model} (${car.plate})`,
        id: car.id,
      }))];
    }
    tabs.push(
      {
        label: null,
        id: 'new',
      }
    )
    return tabs;
  }

  showAddCarForm = () => {
    this.props.showAddCarForm();
  }

  onTabSelect = (selected, selectedIndex) => {
    const currentIndex = this.state.tabSelected;
    this.setState({
      tabSelected: selectedIndex,
      lastSelected: currentIndex});
  }

  onAddButton = index => () => {
    this.onTabSelect(null, index);
    this.props.onShowFormBlank();
  }

  render() {
    const {cars, permissions} = this.props;
    if (!permissions) {
      return null;
    }
    const tabs = this.buildContent(cars);
    const {tabSelected} = this.state;
    
    return (
      <Container id='cars'>
        <Tabs
          onSelect={this.onTabSelect}
          selected={tabSelected ? tabSelected : tabs[0]}
          components={{Content: CarPage}}
          tabs={tabs}
        />
        {tabs.length > 1 && permissions.add && (
          <AddCarButtonWrapper>
            <Button spacing='compact' onClick={this.onAddButton(tabs.length - 1)}>
              <Trans>
                Add
              </Trans>
            </Button>
          </AddCarButtonWrapper>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.client && state.userProfile.permissions.client.car,
    cars: CarsSelectors.getCars(state),
    fetching: state.cars.fetching,
    error: state.cars.error,
    dictionaries: state.dictionaries,
  };
};

export default connect(
  mapStateToProps,
  null,
)(CarsPage);